import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';

const isManagerRoute = window.location.pathname === '/app' || window.location.pathname.startsWith('/app/');
const isPairDeviceRoute = window.location.pathname === '/pair' || window.location.pathname.startsWith('/pair/');
const FrameApp = React.lazy(() => import('./App'));
const ManagerApp = React.lazy(async () => {
  const module = await import('./components/ManagerApp');
  return { default: module.ManagerApp };
});
const PairDeviceApp = React.lazy(async () => {
  const module = await import('./components/PairDeviceApp');
  return { default: module.PairDeviceApp };
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <React.Suspense fallback={<main className="route-loading">Loading PortalFrame…</main>}>
      {isManagerRoute ? <ManagerApp /> : isPairDeviceRoute ? <PairDeviceApp /> : <FrameApp />}
    </React.Suspense>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
